import { render, staticRenderFns } from "./ViberCampaignEditRecurring.vue?vue&type=template&id=a1dac48e&scoped=true&"
import script from "./ViberCampaignEditRecurring.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignEditRecurring.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignEditRecurring.vue?vue&type=style&index=0&id=a1dac48e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dac48e",
  null
  
)

export default component.exports